import React, { Suspense, lazy } from "react";
import MainLayout from "src/layouts/MainLayout";
import HomeView from "src/views/home/HomeView";
import LoadingScreen from "src/components/LoadingScreen";
import { Route, Routes, Navigate } from "react-router-dom";

const NotFoundComp = lazy(() => import("src/views/errors/NotFoundView"));
const ProductsView = lazy(() => import("src/views/products"));
const ProductDetail = lazy(() => import("src/views/products/ProductDetail"));
const AboutView = lazy(() => import("src/views/about"));

export const renderRoutes = () => (
    <Suspense fallback={<LoadingScreen />}>
        <Routes>
            <Route element={<MainLayout />}>
                <Route index element={<HomeView />} exact />
                <Route path="products" element={<ProductsView />} />
                <Route path="products/:productId" element={<ProductDetail />} />
                <Route path="about" element={<AboutView />} />
                <Route path="*" element={<Navigate to="/404" />} />
            </Route>
            <Route path="404" element={<NotFoundComp />} />
        </Routes>
    </Suspense>
);
